import { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from '../../textBoxWithTooltip';
import ActionButton from '../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    borderRadius: 4,
  },
  presetItem: {
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    padding: spacing(2),
    justifyContent: 'space-between',
  },
  hover: {
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: primary.bluish8,
    },
  },
  selectedPreset: {
    backgroundColor: primary.bluish9,
    '& > div > p': {
      fontFamily: 'ProximaNova-Bold',
    },
    '& > p': {
      fontFamily: 'ProximaNova-Bold',
    },
  },
  presetName: {
    maxWidth: 'calc(100% - 6px)',
  },
  button: {
    display: 'flex',
    flexShrink: 0,
    width: 24,
    height: 24,
  },
  buttonIcon: {
    width: 18,
    height: 18,
  },
}));

const VirtualPreset = ({
  translations,
  preset,
  isSelected,
  onApply,
  onDelete,
  onPlaceholder,
}) => {
  const classes = useStyles();

  const handleApply = useCallback(
    () => (isSelected ? null : onApply(preset)),
    [preset, isSelected, onApply]
  );

  const handleDelete = useCallback(
    e => {
      e.stopPropagation();
      if (isSelected) {
        onPlaceholder(translations.startSearch);
      }
      onDelete(preset);
    },
    [translations, preset, isSelected, onDelete, onPlaceholder]
  );

  return (
    <div className={classes.root}>
      <div
        className={classNames(classes.presetItem, classes.hover, {
          [classes.selectedPreset]: isSelected,
        })}
        onClick={handleApply}
      >
        <TextBoxWithTooltip
          className={classes.presetName}
          variant="body1"
          text={preset.name}
        />
        <ActionButton
          className={classes.button}
          iconClass={classes.buttonIcon}
          type={ACTION_BUTTON_TYPES.DELETE_FILL}
          onClickHandler={handleDelete}
        />
      </div>
    </div>
  );
};

VirtualPreset.propTypes = {
  translations: PropTypes.object.isRequired,
  preset: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onApply: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPlaceholder: PropTypes.func.isRequired,
};

export default memo(VirtualPreset);
